<template>
  <div class="statistics-container" :class="device.isMobile ? 'statistics-container-mobile' : ''">
    <div class="content">
      <div class="title">1.你认为数字教材应该具备哪些功能？</div>
      <div class="charts" id="charts-1"></div>
    </div>
    <div class="content">
      <div class="title">2．想一想，纸质教材和数字教材有什么区别呢？</div>
      <div class="charts-box">
        <div class="charts" id="charts-2"></div>
        <div class="info">参考答案：纸质教材和数字教材在交互性、动态性、多元性、针对性、便携性等方面存在区别。</div>
      </div>
    </div>
    <div class="content">
      <div class="title">3．你知道文旌课堂吗？</div>
      <div class="charts" id="charts-3"></div>
    </div>
    <!-- <div class="content-list">
      <div class="content-item">
        <div class="title">2．想一想，纸质教材和数字教材有什么区别呢？</div>
        <div class="charts" id="charts-2"></div>
      </div>
      <div class="content-item">
        <div class="title">3．你知道文旌课堂吗？</div>
        <div class="charts" id="charts-3"></div>
      </div>
    </div> -->
  </div>
</template>

<script>
/*
统计数据
*/
import * as echarts from 'echarts';
import 'echarts-wordcloud';
export default {
  name: "statisticsIndex",
  components: {
    
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
  data() {
    return {
      chartsData1: [
        { id: 1, value: 11, name: '多媒体集成功能' },
        { id: 2, value: 16, name: '交互功能' },
        { id: 3, value: 11, name: '跟踪与反馈功能' },
        { id: 4, value: 8, name: '教学辅助功能' },
        { id: 5, value: 1, name: '其他' },
      ],
      chartsData3: [
        { id: 1, value: 17, name: '知道' },
        { id: 2, value: 8, name: '不知道' },
      ],
    }
  },
  mounted() {
    this.initCharts1();
    this.initCharts2();
    this.initCharts3();
  },
  methods: {
    initCharts1() {
      let chartDom = document.getElementById('charts-1');
      let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {

        },
        yAxis: {
          data: ['交互功能', '跟踪与反馈功能', '多媒体集成功能', '教学辅助功能', '其他'],
          axisTick: {
            alignWithLabel: true
          },
          inverse: true
        },
        series: [
          {
            type: 'bar',
            data: [16, 11, 11, 8, 1],
            itemStyle: {
              // 修改柱状图颜色
              color: '#2D94E6'
            },
            barGap: '20%',
            barWidth: 25,//柱图宽度
          }
        ],
        grid: {
          top: "15%", // 顶部距离
          bottom: "15%", // 底部距离
          left: 120, // 左侧距离
          right: "2%" // 右侧距离
        }
      }
      option && myChart.setOption(option);
    },
    initCharts2() {
      let chartDom = document.getElementById('charts-2');
      let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        series: [
          {
            type: 'wordCloud',
            shape: 'circle',
            sizeRange: this.device.isMobile ? [8, 18] : [14, 30],
            rotationRange: [0, 0],
            textStyle: {
              fontFamily: 'sans-serif',
              fontWeight: 'bold',
              // Color can be a callback function or a color string
              color: function () {
                // Random color
                return 'rgb(' + [
                  Math.round(Math.random() * 160),
                  Math.round(Math.random() * 160),
                  Math.round(Math.random() * 160)
                ].join(',') + ')';
              }
            },
            data: [
              { value: '30', name: '内容形式' },
              { value: '29', name: '实时' },
              { value: '28', name: '功能' },
              { value: '27', name: '印刷' },
              { value: '26', name: '重量' },
              { value: '25', name: '素材' },
              { value: '24', name: '交互' },
              { value: '23', name: '时效性' },
              { value: '22', name: '载体' },
              { value: '21', name: '美观度' },
              { value: '20', name: '成本' },
              { value: '16', name: '技术' },
              { value: '15', name: '更新' },
              { value: '14', name: '媒体' },
              { value: '13', name: '互联网' },
              { value: '12', name: '体积' },
              { value: '11', name: '设备' },
              { value: '10', name: '及时' },
            ]
          }
        ]
      }
      option && myChart.setOption(option);
    },
    initCharts3() {
      let chartDom = document.getElementById('charts-3');
      let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            data: [
              { value: 17, name: '知道' },
              { value: 8, name: '不知道' },
            ],
            
            itemStyle: {
              normal: {
                color: function(params) {
                  // 预定义一个颜色数组
                  var colorList = [
                    '#2D94E6','#43D3AC'
                  ];
                  // 返回每个饼图扇区的颜色，从颜色数组中循环选择
                  return colorList[params.dataIndex % colorList.length];
                }
              }
            }
          }
        ]
      }
      option && myChart.setOption(option);
    },
  }
}
</script>

<style lang="scss" scoped>
.statistics-container{
  padding: 0 24rem;
  text-indent: 0;

  .content{
    width: 100%;
    height: 170rem;

    .title{
      font-size: 18rem;
      color: #333;
      font-weight: bold;
    }

    .charts{
      width: 100%;
      height: 140rem;
    }

    .charts-box{
      width: 100%;
      height: 140rem;
      display: flex;
      align-items: center;

      .charts{
        width: 300rem;
        height: 140rem;
      }

      .info{
        width: 300rem;
        font-size: 16rem;
        line-height: 24rem;
        color: #333;
      }
    }

    &:first-child{
      height: 270rem;

      .charts{
        height: 240rem;
      }
    }
  }

  .content-list{
    width: 100%;
    height: 300rem;
    display: flex;

    .content-item{
      width: 50%;
      height: 300rem;

      .charts{
        width: 100%;
        height: 270rem;
      }
    }
  }
}

.statistics-container-mobile{
  .content{
    width: 100%;
    height: 250rem;

    .title{
      font-size: 28rem;
      color: #333;
      font-weight: bold;
      margin-top: 40rem;
    }

    .charts{
      width: 100%;
      height: 250rem;
    }

    .charts-box{
      width: 100%;
      height: 250rem;
      display: flex;
      align-items: center;

      .charts{
        width: 300rem;
        height: 250rem;
      }

      .info{
        width: 300rem;
        font-size: 24rem;
        line-height: 36rem;
        color: #333;
      }
    }

    &:first-child{
      height: 400rem;

      .charts{
        height: 400rem;
      }
    }
  }
}
</style>